// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SimilarStrollers__headline":"xf_a bhe_uj bhe_ua bhe_vx bhe_qk bhe_sl bhe_qb"};